import {CoreObjectId, DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';

export default function isProcedureVersionPoW(version: string): boolean {
  try {
    return getObjectType({id: version as CoreObjectId}) === DomainGraphType.WORKFLOW_FLOWCHART_CONFIG_VERSION;
    // eslint-disable-next-line benchlint/always-throw-from-catch
  } catch (e) {
    // If the ID doesn't have a valid prefix, it's not a PoW version
    return false;
  }
}
